import ExportMethod from "./apis/ExportMethod";

// Rows may arrive as `{ data: [...] }` (paginated response) or as a bare array.
const rowsOf = (data) => (Array.isArray(data) ? data : data?.data || []);

const download = ({ content, type, name }) => {
  const blob = new Blob([content], { type });
  const link = document.createElement("a");
  link.href = URL.createObjectURL(blob);
  link.download = name;
  link.click();
};

/**
 * Builds a CSV / Excel / Print trio for one table.
 *
 * `columns` is a list of `{ name, value(row), excel?(row) }`:
 *  - `name`   header text
 *  - `value`  cell value for CSV and Print
 *  - `excel`  optional override for Excel only (e.g. to keep long numbers as text)
 *
 * Each table (Users, Report, ...) calls this with its own columns, so every
 * export matches the table it is launched from.
 */
export const createExporters = (columns) => {
  const header = columns.map(({ name }) => ({ name }));
  const toRows = (data, excel = false) =>
    rowsOf(data).map((row) =>
      columns.map((c) => (excel && c.excel ? c.excel(row) : c.value(row))),
    );

  return {
    csv: (data, file) =>
      download(ExportMethod.csv(toRows(data), header, file)),
    excel: (data, file) =>
      download(ExportMethod.excel(toRows(data, true), header, file)),
    print: (data) => {
      const content = ExportMethod.print(toRows(data), header);
      const printWindow = window.open("", "_blank");
      printWindow.document.write(content);
      printWindow.document.close();
      printWindow.print();
    },
  };
};
